import * as React from "react"
import { Widget, mk_widget, any } from "widgets-for-react"
import { styleguideChapter, styleguideSection, styleguidePart, styleguideExample } from "../helpers"

export const styleguideCompositions: Widget<never> = mk_widget({
  run: _ => (
    styleguideChapter({ type: 'compositions', slug: 'compositions', title: 'Design Compositions', intro: ''})(
      any()([
        styleguideSection({ type: 'compositions', slug: 'compositions-homepage', title: 'Homepage', intro: ''})(
          any()([
            styleguidePart({ title: '', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: true })(
                mk_widget({
                  run: _ => (
                    <></>
                  )
                })
              )
            )
          ])
        )
      ])
    ).run(_)
  )
})
